// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"16a97135","133":"1cb6e97e","182":"096aaf6b"}[chunkId] + ".chunk.js";
};